import { render, staticRenderFns } from "./messageMain.vue?vue&type=template&id=70700aca&scoped=true"
import script from "./messageMain.vue?vue&type=script&lang=js"
export * from "./messageMain.vue?vue&type=script&lang=js"
import style0 from "./messageMain.vue?vue&type=style&index=0&id=70700aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.6_css-loader@6.11.0_webpack@5.94.0__lodash@4.1_3e53857b11c59041ac2156933ceb8b47/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70700aca",
  null
  
)

export default component.exports